import { useQueryWrapper, useSelectedShop } from "shared/hooks";
import { getUpliftMetrics } from "../api";
import { useDateRangeContext } from "./useDateRangeContext";

export const useUpliftMetrics = () => {
  const { selectedShopId } = useSelectedShop();

  const { startDate, endDate } = useDateRangeContext();

  const { data, isLoading } = useQueryWrapper(
    ["upliftMetrics", selectedShopId, startDate?.toString(), endDate?.toString()],
    async () => await getUpliftMetrics(selectedShopId!, startDate!, endDate!),
    {
      enabled: !!selectedShopId && !!startDate && !!endDate,
      refetchOnWindowFocus: false,
      retry: false
    }
  );

  return { data, loading: isLoading };
};
